import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'
import { Loading } from 'components/core-v2/pages'

import { TaxReportForm } from '../pages/TaxReportForm'

interface Props {
  isLoading: boolean
}

export const TaxReportsTemplate = ({ isLoading }: Props) => (
  <LeftSideBar
    leftElement={<Navigation />}
    mainElement={isLoading ? <Loading /> : <TaxReportForm />}
    topBarElement={<UserMenuTopBar />}
  />
)
